/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Broker } from '../models/Broker';
import type { CreateBrokerBody } from '../models/CreateBrokerBody';
import type { UpdateBrokerBody } from '../models/UpdateBrokerBody';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BrokersService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns any Brokers
   * @throws ApiError
   */
  public searchBrokers({
    limit,
    after,
    term,
  }: {
    limit?: number,
    after?: string,
    term?: string,
  }): CancelablePromise<{
    items: Array<Broker>;
    total: number;
    next: string | null;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/brokers',
      query: {
        'limit': limit,
        'after': after,
        'term': term,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns Broker The Broker
   * @throws ApiError
   */
  public createBroker({
    requestBody,
  }: {
    /**
     * Broker details to be created
     */
    requestBody: CreateBrokerBody,
  }): CancelablePromise<Broker> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/core/brokers',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

  /**
   * @returns Broker The Broker
   * @throws ApiError
   */
  public findBroker({
    id,
  }: {
    id: string,
  }): CancelablePromise<Broker> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/core/brokers/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        404: `Not Found Error`,
      },
    });
  }

  /**
   * @returns Broker The Broker
   * @throws ApiError
   */
  public updateBroker({
    id,
    requestBody,
  }: {
    id: string,
    /**
     * The Broker
     */
    requestBody: UpdateBrokerBody,
  }): CancelablePromise<Broker> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/core/brokers/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Malformed Error`,
        401: `Auth Error`,
        403: `Forbidden Error`,
        422: `Invalid Error`,
      },
    });
  }

}
